import { Dashboard } from '../../models/Dashboard'
import { RecordDataMap } from '../../models/RecordDataMap'
import { getViewTitleFromView } from '../../utils/dashboard'
import Paragraph from '../app/design/Paragraph'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../app/design/Table'
import { DashboardSkeleton } from '../common/skeletons/DashboardSkeleton'
import { EmptyDashboardLayout } from './EmptyDashboardLayout'
import { KeyMetric } from './KeyMetric'

type Props = {
    links: RecordDataMap[]
    view: number
    dashboard?: Dashboard
    searchText: string
    isLoading: boolean
}

export function LinksDashboard({ links, view, dashboard, searchText, isLoading }: Props) {
    if (isLoading) {
        return <DashboardSkeleton />
    }

    return (
        <div className="flex flex-col gap-6">
            <KeyMetric
                metrics={[
                    {
                        title: `${getViewTitleFromView(dashboard, view)}`,
                        value: (dashboard?.value ?? 0).toString(),
                    },
                ]}
            />
            <Table>
                <TableHeader>
                    <TableRow location="head">
                        <TableHead className="font-normal">
                            {view === 2 ? 'Link' : 'Referrer'}
                        </TableHead>
                        <TableHead className="text-right font-normal">
                            {view === 2 ? 'Count' : 'Percent'}
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {links.map((link) => {
                        const referer = link.valueForKey('referer')
                        const title = view === 2 ? link.valueForKey('link') : (referer ?? 'Unknown')
                        const text =
                            view === 2
                                ? link.valueForIntKey('ct')
                                : `${Math.round(link.valueForCurrencyKey('percent') || 0)}%`

                        return (
                            <TableRow key={`link-${title}`}>
                                <TableCell>
                                    <Paragraph size="sm">{title}</Paragraph>
                                </TableCell>
                                <TableCell>
                                    <Paragraph size="sm" className="text-right">
                                        {text}
                                    </Paragraph>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    {links.length === 0 && (
                        <TableCell colSpan={10}>
                            <EmptyDashboardLayout dashboard={dashboard} searchtext={searchText} />
                        </TableCell>
                    )}
                </TableBody>
            </Table>
        </div>
    )
}
